// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__2OBxg","title":"AfterFrontImage_title__U1hh4"};